<template>
  
    
   <section class=" content pb-3">
    <div class="card-header">
              <div class="row">

                    <div class="col-sm-3">
                        <div class="form-group">
                          <label for="exampleInputEmail1">SearchBy Goal</label>
                          
                          <select class="form-control " @change="onChange($event)" v-model="searchProject">
                            <option value="All">All</option>   
                              <option v-for="val in fetchDepart.projects" :key="val.id" :value="val.id">{{val.projectName}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="form-group">
                          <label for="exampleInputEmail1">SearchBy User</label>
                        <select class="form-control" @change="onChangeUser($event)" v-model="searchUser">
                          <option value="All">All</option>   
                          <option v-for="val in getLoginWiseUser" :key="val.userId" :value="val.userId">{{val.name}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="form-group">
                          <label for="exampleInputEmail1">SearchBy Entity</label>
                        <select class="form-control" @change="onChangeEntity($event)" v-model="searchEntity">
                          <option value="All">All</option>   
                          <option v-for="val in getDashboardWiseEntity" :key="val.entyid" :value="val.entyid">{{val.entityname}}</option>
                        </select>
                      </div>
                    </div>
                    <!-- <div class="col-sm-3">
                        <div class="form-group">
                          <label for="exampleInputEmail1">SearchBy MyTask</label>

                        <select class="form-control"  v-model="searchProject">
                                  <option value="day">Day</option>                          
                                  <option value="week">Week</option>                          
                                  <option value="month">Month</option>                          
                        </select>
                      </div>
                    </div> -->
                    <div  class="col-sm-3 card-tools">
                      <label for="exampleInputEmail1"></label>
                      <button type="button" class="btn btn-success" data-toggle="modal" data-target="#modal-default-addDepart" style="margin: 30px;">Add Task</button>
                    </div>
                    
              </div>
            
          </div>
        <div class="container-fluid h-100 row">
       
          <div class="card card-row card-primary col-sm-3">
            <div class="card-header">
              <h3 class="card-title">
                TODO
              </h3>
            </div>
            <draggable class="card-body" group="tasks" :animation="200" v-model="fetchTODO" item-key="id"  @change="log1" >
              
              <template  #item="{element}">
                <div  class="card card-info card-outline" style="border-top: 3px solid #007bff;" data-toggle="modal" data-target="#modal-default" @click="taskActivity(element.taskid)">
                  <div class="card-header">
                    <h5 class="card-title">{{element.title}} (Goal:{{element.projectdetails}})</h5>
                    <div class="card-tools" >
                    <a href="#" class="btn btn-tool btn-link">
                      <span v-if="element.priority=='Urgent'" title="Urgent">
                        <svg style="color: red;" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" class="svg" fill="currentColor" focusable="false"><path d="M10.04 1.3a.5.5 0 01.66-.26A7.8 7.8 0 0115 8.48v.03a.5.5 0 01-1-.01v-.05c.02-.34.1-2.16-.93-3.86a7.21 7.21 0 00-2.77-2.63.5.5 0 01-.26-.66z"></path><path d="M10.1 3.71a.5.5 0 01.7-.11c-.01 0 .23.15.51.4a4.51 4.51 0 011.46 3.19v.06a.5.5 0 01-1 0 3.48 3.48 0 00-1.56-2.84.5.5 0 01-.12-.7z"></path><path d="M2.54 10.7a4 4 0 016.92-4l.82 1.43L12.2 9.5a.5.5 0 01-.04.84l-2.53 1.46-2.74 1.58-2.53 1.46a.5.5 0 01-.75-.38l-.24-2.34-.82-1.42z"></path><path d="M10.25 12.6l-3 1.74a1.75 1.75 0 003-1.73z"></path></svg>
                      </span>
                      <span v-if="element.priority=='Important'">
                        <svg style="color:red" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" class="svg" fill="currentColor" focusable="false"><path d="M5.96 4.46a2.07 2.07 0 114.08 0l-.86 4.56a1.2 1.2 0 01-2.36 0l-.86-4.56z"></path><path d="M9.5 12.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"></path></svg>
                      </span>
                    </a>
                   
                    <!-- <button type="button" class="btn btn-default" data-toggle="modal" data-target="#modal-default"> <i class="fas fa-pen"></i></button> -->
                    
                  </div>
                  
                  <br/>
                  
                  <div class="mt-3">
                    <span class="m2-1" style="font-size:10px;">Created By: {{element.userdetails}}</span>&nbsp;
                    <span style="font-size:10px;">Assign to: {{element.assigndetails}}</span>
                  </div>
                  <div>
                    <svg v-if="element.lastaction"  title="Has Action Logs " style="color:#1834ec" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" class="svg" fill="currentColor" focusable="false"><path d="M6 7c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3A.5.5 0 016 7z"></path><path d="M6.5 8.5a.5.5 0 000 1h2a.5.5 0 000-1h-2z"></path><path d="M2 8a6 6 0 113 5.2l-2.34.77a.5.5 0 01-.64-.6l.71-2.5A5.98 5.98 0 012 8zm6-5a5 5 0 00-4.3 7.55.5.5 0 01.05.4l-.5 1.78 1.65-.56a.5.5 0 01.43.06A5 5 0 108 3z"></path></svg>
                    <span v-if="element.checklisttotal" class="ms-Button-flexContainer flexContainer-262 ml-3" data-automationid="splitbuttonprimary">
                      <i data-icon-name="plannerChecklistSmall" aria-hidden="true" class="ms-Icon root-90 ms-Button-icon plannerIcon plannerChecklistSmall icon-264 plannerIcon plannerChecklistSmall css-99">
                        <span  title="checklist Item completed" class="root-span css-98" aria-hidden="true">
                          <svg style="color:#1834ec" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" class="svg" fill="currentColor" focusable="false"><path d="M8 2a6 6 0 110 12A6 6 0 018 2zm0 1a5 5 0 100 10A5 5 0 008 3zm-.75 6.04l2.87-2.88a.5.5 0 01.77.64l-.06.07L7.6 10.1a.5.5 0 01-.63.06l-.07-.06-1.75-1.75a.5.5 0 01.63-.76l.07.06 1.4 1.4 2.87-2.89-2.87 2.88z"></path></svg></span></i><span class="ms-Button-textContainer textContainer-263">
                            <span class="ms-Button-label label-265" id="id__168" style="font-size: 13px;">{{element.checklistStatus?element.checklistStatus:0}} / {{element.checklisttotal}}</span></span></span>
                  </div>
                                 
                  </div>
                  
                  <div class="bottomBar css-285" style="height: 39px;">
                    <div class="bottomBarLeftSection">
                      <div class="dueDateIndicator css-283 clickable isLate" aria-label=" Due date " title=" Due Date" data-is-focusable="false" role="button" tabindex="-1">
                        <i data-icon-name="plannerCalendar" aria-hidden="true" class="calendarIcon plannerIcon plannerCalendar root-286">
                          
                        </i>
                        <span class="calendarLabel css-285 label mr-4" tabindex="-1" style="color:red;font-size:10px">{{format_date(element.duedate)}}</span>
                        <span class="calendarLabel css-285 label ml-3" tabindex="-1" style="color:red;font-size:10px">Last Action: {{ format_date1(element.lastaction)}}</span>
                      </div>
                    </div>
                  
                    </div>

                    </div>
                    
                    </template>
            </draggable>

           
          </div>
          <div class="card card-row card-secondary col-sm-3">
            <div class="card-header">
              <h3 class="card-title">
                In-Progress
              </h3>
            </div>
            <draggable class="card-body"   group="tasks" :animation="200" v-model="fetchINPROGRESS" item-key="id"  @change="log2"  >
              
              <template  #item="{element}">
                <div  class="card card-info card-outline" style="border-top: 3px solid #6c757d;" data-toggle="modal" data-target="#modal-default" @click="taskActivity(element.taskid)">
                  <div class="card-header" >
                    <h5 class="card-title"> {{element.title}} (Goal:{{element.projectdetails}})</h5>
                    <div class="card-tools" @click="taskActivity(element.taskid)">
                      <a href="#" class="btn btn-tool btn-link">
                      <span v-if="element.priority=='Urgent'" title="Urgent">
                        <svg style="color: red;" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" class="svg" fill="currentColor" focusable="false"><path d="M10.04 1.3a.5.5 0 01.66-.26A7.8 7.8 0 0115 8.48v.03a.5.5 0 01-1-.01v-.05c.02-.34.1-2.16-.93-3.86a7.21 7.21 0 00-2.77-2.63.5.5 0 01-.26-.66z"></path><path d="M10.1 3.71a.5.5 0 01.7-.11c-.01 0 .23.15.51.4a4.51 4.51 0 011.46 3.19v.06a.5.5 0 01-1 0 3.48 3.48 0 00-1.56-2.84.5.5 0 01-.12-.7z"></path><path d="M2.54 10.7a4 4 0 016.92-4l.82 1.43L12.2 9.5a.5.5 0 01-.04.84l-2.53 1.46-2.74 1.58-2.53 1.46a.5.5 0 01-.75-.38l-.24-2.34-.82-1.42z"></path><path d="M10.25 12.6l-3 1.74a1.75 1.75 0 003-1.73z"></path></svg>
                      </span>
                      <span v-if="element.priority=='Important'">
                        <svg style="color:red" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" class="svg" fill="currentColor" focusable="false"><path d="M5.96 4.46a2.07 2.07 0 114.08 0l-.86 4.56a1.2 1.2 0 01-2.36 0l-.86-4.56z"></path><path d="M9.5 12.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"></path></svg>
                      </span>
                    </a>
                    <!-- <button type="button" class="btn btn-default" data-toggle="modal" data-target="#modal-default"> <i class="fas fa-pen"></i></button> -->

                    <!-- <a class="btn btn-tool">
                      <i class="fas fa-pen"></i>
                    </a> -->
                  </div>
                  <br/>
                  <div class="mt-3">
                    <span class="m2-1" style="font-size:10px;">Created By: {{element.userdetails}}</span>&nbsp;
                    <span style="font-size:10px;">Assign to: {{element.assigndetails}}</span>
                  </div>
                  <div>
                    <svg  v-if="element.lastaction" title="Has Action Logs " style="color:#1834ec" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" class="svg" fill="currentColor" focusable="false"><path d="M6 7c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3A.5.5 0 016 7z"></path><path d="M6.5 8.5a.5.5 0 000 1h2a.5.5 0 000-1h-2z"></path><path d="M2 8a6 6 0 113 5.2l-2.34.77a.5.5 0 01-.64-.6l.71-2.5A5.98 5.98 0 012 8zm6-5a5 5 0 00-4.3 7.55.5.5 0 01.05.4l-.5 1.78 1.65-.56a.5.5 0 01.43.06A5 5 0 108 3z"></path></svg>
                    <span v-if="element.checklisttotal" class="ms-Button-flexContainer flexContainer-262 ml-3" data-automationid="splitbuttonprimary">
                      <i data-icon-name="plannerChecklistSmall" aria-hidden="true" class="ms-Icon root-90 ms-Button-icon plannerIcon plannerChecklistSmall icon-264 plannerIcon plannerChecklistSmall css-99">
                        <span  title="checklist Item completed" class="root-span css-98" aria-hidden="true">
                          <svg style="color:#1834ec" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" class="svg" fill="currentColor" focusable="false"><path d="M8 2a6 6 0 110 12A6 6 0 018 2zm0 1a5 5 0 100 10A5 5 0 008 3zm-.75 6.04l2.87-2.88a.5.5 0 01.77.64l-.06.07L7.6 10.1a.5.5 0 01-.63.06l-.07-.06-1.75-1.75a.5.5 0 01.63-.76l.07.06 1.4 1.4 2.87-2.89-2.87 2.88z"></path></svg></span></i><span class="ms-Button-textContainer textContainer-263">
                            <span class="ms-Button-label label-265" id="id__168" style="font-size: 13px;">{{element.checklistStatus?element.checklistStatus:0}} / {{element.checklisttotal}}</span></span></span>
                  </div>

                 
                  </div>
                
                    <div class="bottomBar css-285" style="height: 39px;">
                    <div class="bottomBarLeftSection">
                      <div class="dueDateIndicator css-283 clickable isLate" aria-label=" Due date " title=" Due Date" data-is-focusable="false" role="button" tabindex="-1">
                        <i data-icon-name="plannerCalendar" aria-hidden="true" class="calendarIcon plannerIcon plannerCalendar root-286">
                          
                        </i>
                        <span class="calendarLabel css-285 label mr-4" tabindex="-1" style="color:red;font-size:10px">{{format_date(element.duedate)}}</span>
                        <span class="calendarLabel css-285 label ml-3" tabindex="-1" style="color:red;font-size:10px">Last Action: {{ format_date1(element.lastaction)}}</span>
                      </div>
                    </div>
                  
                    </div>
                    </div>
                    </template>
            </draggable>

           
          </div>
          <div class="card card-row card-warning col-sm-3">
            <div class="card-header">
              <h3 class="card-title">
                Review
              </h3>
            </div>
            <draggable class="card-body"   group="tasks" :animation="200" v-model="fetchTESTING" item-key="id"  >
              
              <template  #item="{element}">
                <div  class="card card-info card-outline" style="border-top: 3px solid #ffc107;" data-toggle="modal" data-target="#modal-default" @click="taskActivity(element.taskid)">
                  <div class="card-header">
                    <h5 class="card-title"> {{element.title}} (Goal:{{element.projectdetails}})</h5>
                    <div class="card-tools" @click="taskActivity(element.taskid)">
                      <a href="#" class="btn btn-tool btn-link">
                      <span v-if="element.priority=='Urgent'" title="Urgent">
                        <svg style="color: red;" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" class="svg" fill="currentColor" focusable="false"><path d="M10.04 1.3a.5.5 0 01.66-.26A7.8 7.8 0 0115 8.48v.03a.5.5 0 01-1-.01v-.05c.02-.34.1-2.16-.93-3.86a7.21 7.21 0 00-2.77-2.63.5.5 0 01-.26-.66z"></path><path d="M10.1 3.71a.5.5 0 01.7-.11c-.01 0 .23.15.51.4a4.51 4.51 0 011.46 3.19v.06a.5.5 0 01-1 0 3.48 3.48 0 00-1.56-2.84.5.5 0 01-.12-.7z"></path><path d="M2.54 10.7a4 4 0 016.92-4l.82 1.43L12.2 9.5a.5.5 0 01-.04.84l-2.53 1.46-2.74 1.58-2.53 1.46a.5.5 0 01-.75-.38l-.24-2.34-.82-1.42z"></path><path d="M10.25 12.6l-3 1.74a1.75 1.75 0 003-1.73z"></path></svg>
                      </span>
                      <span v-if="element.priority=='Important'">
                        <svg style="color:red" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" class="svg" fill="currentColor" focusable="false"><path d="M5.96 4.46a2.07 2.07 0 114.08 0l-.86 4.56a1.2 1.2 0 01-2.36 0l-.86-4.56z"></path><path d="M9.5 12.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"></path></svg>
                      </span>
                    </a>                    <!-- <button type="button" class="btn btn-default" data-toggle="modal" data-target="#modal-default"> <i class="fas fa-pen"></i></button> -->

                    <!-- <a href="#" class="btn btn-tool">
                      <i class="fas fa-pen"></i>
                    </a> -->
                  </div>
                  <br/>
                  <div class="mt-3">
                    <span class="m2-1" style="font-size:10px;">Created By: {{element.userdetails}}</span>&nbsp;
                    <span style="font-size:10px;">Assign to: {{element.assigndetails}}</span>
                  </div>

                  <div>
                    <svg  v-if="element.lastaction" title="Has Action Logs " style="color:#1834ec" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" class="svg" fill="currentColor" focusable="false"><path d="M6 7c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3A.5.5 0 016 7z"></path><path d="M6.5 8.5a.5.5 0 000 1h2a.5.5 0 000-1h-2z"></path><path d="M2 8a6 6 0 113 5.2l-2.34.77a.5.5 0 01-.64-.6l.71-2.5A5.98 5.98 0 012 8zm6-5a5 5 0 00-4.3 7.55.5.5 0 01.05.4l-.5 1.78 1.65-.56a.5.5 0 01.43.06A5 5 0 108 3z"></path></svg>
                    <span v-if="element.checklisttotal" class="ms-Button-flexContainer flexContainer-262 ml-3" data-automationid="splitbuttonprimary">
                      <i data-icon-name="plannerChecklistSmall" aria-hidden="true" class="ms-Icon root-90 ms-Button-icon plannerIcon plannerChecklistSmall icon-264 plannerIcon plannerChecklistSmall css-99">
                        <span  title="checklist Item completed" class="root-span css-98" aria-hidden="true">
                          <svg style="color:#1834ec" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" class="svg" fill="currentColor" focusable="false"><path d="M8 2a6 6 0 110 12A6 6 0 018 2zm0 1a5 5 0 100 10A5 5 0 008 3zm-.75 6.04l2.87-2.88a.5.5 0 01.77.64l-.06.07L7.6 10.1a.5.5 0 01-.63.06l-.07-.06-1.75-1.75a.5.5 0 01.63-.76l.07.06 1.4 1.4 2.87-2.89-2.87 2.88z"></path></svg></span></i><span class="ms-Button-textContainer textContainer-263">
                            <span class="ms-Button-label label-265" id="id__168" style="font-size: 13px;">{{element.checklistStatus?element.checklistStatus:0}} / {{element.checklisttotal}}</span></span></span>
                  </div>
                  </div>
                 

                    <div class="bottomBar css-285" style="height: 39px;">
                    <div class="bottomBarLeftSection">
                      <div class="dueDateIndicator css-283 clickable isLate" aria-label=" Due date " title=" Due Date" data-is-focusable="false" role="button" tabindex="-1">
                        <i data-icon-name="plannerCalendar" aria-hidden="true" class="calendarIcon plannerIcon plannerCalendar root-286">
                          
                        </i>
                        <span class="calendarLabel css-285 label mr-4" tabindex="-1" style="color:red;font-size:10px">{{format_date(element.duedate)}}</span>
                        <span class="calendarLabel css-285 label ml-3" tabindex="-1" style="color:red;font-size:10px">Last Action: {{ format_date1(element.lastaction)}}</span>
                      </div>
                    </div>
                  
                    </div>

                    </div>
                    </template>
            </draggable>

           
          </div>
          <div class="card card-row card-success col-sm-3">
            <div class="card-header">
              <h3 class="card-title">
                Done
              </h3>
            </div>
            <draggable class="card-body"   group="tasks" :animation="200"  v-model="fetchDONE" item-key="id"  >
              
              <template  #item="{element}">
                <div  class="card card-info card-outline" style="border-top: 3px solid #28a745;" data-toggle="modal" data-target="#modal-default" @click="taskActivity(element.taskid)">
                  <div class="card-header">
                    <h5 class="card-title"> {{element.title}} (Goal:{{element.projectdetails}})</h5>
                    <div class="card-tools" @click="taskActivity(element.taskid)">
                      <a href="#" class="btn btn-tool btn-link">
                      <span v-if="element.priority=='Urgent'" title="Urgent">
                        <svg style="color: red;" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" class="svg" fill="currentColor" focusable="false"><path d="M10.04 1.3a.5.5 0 01.66-.26A7.8 7.8 0 0115 8.48v.03a.5.5 0 01-1-.01v-.05c.02-.34.1-2.16-.93-3.86a7.21 7.21 0 00-2.77-2.63.5.5 0 01-.26-.66z"></path><path d="M10.1 3.71a.5.5 0 01.7-.11c-.01 0 .23.15.51.4a4.51 4.51 0 011.46 3.19v.06a.5.5 0 01-1 0 3.48 3.48 0 00-1.56-2.84.5.5 0 01-.12-.7z"></path><path d="M2.54 10.7a4 4 0 016.92-4l.82 1.43L12.2 9.5a.5.5 0 01-.04.84l-2.53 1.46-2.74 1.58-2.53 1.46a.5.5 0 01-.75-.38l-.24-2.34-.82-1.42z"></path><path d="M10.25 12.6l-3 1.74a1.75 1.75 0 003-1.73z"></path></svg>
                      </span>
                      <span v-if="element.priority=='Important'">
                        <svg style="color:red" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" class="svg" fill="currentColor" focusable="false"><path d="M5.96 4.46a2.07 2.07 0 114.08 0l-.86 4.56a1.2 1.2 0 01-2.36 0l-.86-4.56z"></path><path d="M9.5 12.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"></path></svg>
                      </span>
                    </a>                      <!-- <button type="button" class="btn btn-default" data-toggle="modal" data-target="#modal-default"> <i class="fas fa-pen"></i></button> -->

                   
                  </div>
                  <br/>
                  <div class="mt-3">
                    <span class="m2-1" style="font-size:10px;">Created By: {{element.userdetails}}</span>&nbsp;
                    <span style="font-size:10px;">Assign to: {{element.assigndetails}}</span>
                  </div>

                  <div>
                    <svg  v-if="element.lastaction"  title="Has Action Logs " style="color:#1834ec" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" class="svg" fill="currentColor" focusable="false"><path d="M6 7c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3A.5.5 0 016 7z"></path><path d="M6.5 8.5a.5.5 0 000 1h2a.5.5 0 000-1h-2z"></path><path d="M2 8a6 6 0 113 5.2l-2.34.77a.5.5 0 01-.64-.6l.71-2.5A5.98 5.98 0 012 8zm6-5a5 5 0 00-4.3 7.55.5.5 0 01.05.4l-.5 1.78 1.65-.56a.5.5 0 01.43.06A5 5 0 108 3z"></path></svg>
                    <span v-if="element.checklisttotal" class="ms-Button-flexContainer flexContainer-262 ml-3" data-automationid="splitbuttonprimary">
                      <i data-icon-name="plannerChecklistSmall" aria-hidden="true" class="ms-Icon root-90 ms-Button-icon plannerIcon plannerChecklistSmall icon-264 plannerIcon plannerChecklistSmall css-99">
                        <span  title="checklist Item completed" class="root-span css-98" aria-hidden="true">
                          <svg style="color:#1834ec" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" class="svg" fill="currentColor" focusable="false"><path d="M8 2a6 6 0 110 12A6 6 0 018 2zm0 1a5 5 0 100 10A5 5 0 008 3zm-.75 6.04l2.87-2.88a.5.5 0 01.77.64l-.06.07L7.6 10.1a.5.5 0 01-.63.06l-.07-.06-1.75-1.75a.5.5 0 01.63-.76l.07.06 1.4 1.4 2.87-2.89-2.87 2.88z"></path></svg></span></i><span class="ms-Button-textContainer textContainer-263">
                            <span class="ms-Button-label label-265" id="id__168" style="font-size: 13px;">{{element.checklistStatus?element.checklistStatus:0}} / {{element.checklisttotal}}</span></span></span>
                  </div>
                  </div>
                    <div class="bottomBar css-285" style="height: 39px;">
                    <div class="bottomBarLeftSection">
                      <div class="dueDateIndicator css-283 clickable isLate" aria-label=" Due date " title=" Due Date" data-is-focusable="false" role="button" tabindex="-1">
                        <i data-icon-name="plannerCalendar" aria-hidden="true" class="calendarIcon plannerIcon plannerCalendar root-286">
                          
                        </i>
                        <!-- <span class="calendarLabel css-285 label mr-4" tabindex="-1" style="color:red;font-size:10px">{{format_date(element.duedate)}}</span> -->
                        <span class="calendarLabel css-285 label" tabindex="-1" style="color:Green;font-size:10px"><b>Completed tasks</b></span>

                        <span class="calendarLabel css-285 label ml-3" tabindex="-1" style="color:Green;font-size:10px">Last Action: {{ format_date1(element.lastaction)}}</span>
                      </div>
                    </div>
                  
                    </div>
                    
                    </div>
                    </template>
            </draggable>

           
          </div>
        </div>
      </section>
 <section class="content">
   
     
   
  <div class="modal fade "  id="modal-default" @close="showModal = false">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title text-uppercase">{{tasktitle}}</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <button class="btn btn-success col-sm-3" @click="updateform">Update</button>
              <p style="float:right">{{description}}</p>
              <form v-if="checklistview" @submit.prevent="submitTaskAcitivity">

                <div class="card-body row">
                 
                 <div class="col-sm-6">
                        <div class="form-group">
                            <label for="exampleInputEmail1">Title</label>
                            <input type="text" v-model="tasktitle" class="form-control" id="title" placeholder="Enter title" require>
                        </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="exampleInputEmail1">Description</label>
                      <textarea class="form-control" v-model="description" rows="2" id="description"></textarea>
                    </div>

                  </div>
                  <div class="col-sm-6">
                        <div class="form-group">
                            <label for="exampleInputEmail1">Due Date</label>
                           <input type="date" v-model="editDuedateUpdate" class="form-control" />
                        </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="exampleInputEmail1">Assign Users</label>
                      
                      <input class="form-control" readonly v-model="Tskassignuser" />
                      <!-- <Multiselect
                          v-model="user"
                          mode="tags"
                          placeholder="Select Task Assign User"
                          label="name"
                          valueProp="name"
                          multiplelabel="name"
                          track-by="name"
                          :close-on-select="false"
                          :searchable="true"
                          :options='fetchUsers'></Multiselect> -->
                    </div>
                  </div>
                  
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="exampleInputEmail1">Created By</label>
                      
                      <input class="form-control" readonly v-model="hod" />

                      
                    </div>
                  </div>
                </div>
              
                <!-- /.card-body -->
                <div class="col-sm-12 ml-3">
                        <input type="submit" class="btn btn-success"/>
                      </div>
              </form>
                
            </div>
            <div class="container">
                    
                    <div class="col-sm-12">

                      <div class="card">
              <div class="card-header">
                <h3 class="card-title">
                  <i class="ion ion-clipboard mr-1"></i>
                  Check List 
                </h3>

                <div>
                  <span class="ml-4" >{{count}}/{{fetchChecklist.length}}</span>
                  <div class="progress mb-3">
                  <div class="progress-bar bg-success" role="progressbar" aria-valuenow="2" aria-valuemin="0"
                       aria-valuemax="4"  :style="{ width: maincnt + '%' }">
                    <span class="sr-only">40% Complete (success)</span>
                  </div>
                </div>
                </div>
               
              </div>
             
              <!-- /.card-body -->
              <div class="card-footer clearfix" v-if="checklistview">
                  <div class="row">
                    <div class="col-sm-6">
                      <input type="text" v-model="addchecklist" class="form-control" />

                    </div>
                    <div class="col-sm-6">
                      <button type="button" class="btn btn-primary float-right" @click="addCheckListData" ><i class="fas fa-plus"></i> Add CheckList</button>

                  </div>
                  </div>
              </div>
               <!-- /.card-header -->
               <div class="">
                <ul class="todo-list" data-widget="todo-list">
                  <li v-for="val in fetchChecklist" :key="val">
                    <span class="handle">
                      <i class="fas fa-ellipsis-v"></i>
                      <i class="fas fa-ellipsis-v"></i>
                    </span>
                      <!-- checkbox -->
                      <div  class="icheck-primary d-inline ml-2">
                       
                        <span v-if="val.status=='true'">
                          <input type="checkbox"  id="todoCheck1{{val.id}}" @click="checkboxclick(val, $event)" checked  />
                        </span>
                        <span v-else>
                          <input type="checkbox"  id="todoCheck1{{val.id}}" @click="checkboxclick(val, $event)" />
                        </span>
                        
                      <!-- <input type="checkbox" value="" name="todo1" id="todoCheck1" @click="checkboxclick(this.value)"> -->
                      <label for="todoCheck1{{val.id}}"></label>
                    </div>
                    <!-- todo text -->
                    <span class="text">{{val.checklist1}}</span>
                    <div class="toolss" >
                      <span class="ml-2" style="float:right;    margin-top: -27px;">Created By: <b>{{val.userdetails.name?val.userdetails.name:''}}</b></span>
                      <br/>
                      <!-- <span class="ml-2" style="float:right;    margin-top: -27px;">Date:<b>{{moment(val.sdaate)}}</b></span> -->
                      
                    </div>
                  </li>

                </ul>
              </div>          
            
            </div>
          </div>
                  
                  

                </div>
                <!-- secod -->

                <div class="container">
                  <div class="col-sm-12">
                   
                  <div class="card">
                    <div class="card-header">
                    <h3 class="card-title">
                  <i class="ion ion-clipboard mr-1"></i>
                  Action List 
                </h3>
                </div>
                    <div class="card-footer clearfix" v-if="checklistview">
                       <div class="row">
                          <div class="col-sm-6">
                             <textarea class="form-control" v-model="addaction" rows="5" id="comment"></textarea>
                          </div>
                        <div class="col-sm-6">
                          <button type="button" class="btn btn-primary float-right" @click="addActionListData" ><i class="fas fa-plus"></i> Add Action</button>

                       </div>
                      </div>
                    </div>

             
          
            <div class="card-body">
                <ul class="todo-list" data-widget="todo-list">
                  
                  <li v-for="val in getActionListDash" :key="val">
                    <span class="handle">
                      <i class="fas fa-ellipsis-v"></i>
                      <i class="fas fa-ellipsis-v"></i>
                    </span>

                      <!-- checkbox -->
                      <div  class="icheck-primary d-inline ml-2">                      
                        <div class="text">{{val.actionlist1}}</div>
                    </div>
                    <div class="toolss" >
                      <span class="ml-2" style="float:right;    margin-top: -27px;">Created By: <b>{{val.userdetails.name?val.userdetails.name:''}}</b></span>
                      <br/>
                      <span class="ml-2" style="float:right;    margin-top: -27px;">Date:<b>{{moment(val.sdaate)}}</b></span>
                      
                    </div>
                   </li>

                </ul>
              </div>

                  </div>
                 </div>
                </div>

              <div class="container">
                <div class="col-sm-12">

            <div class="card">
              <div class="card-header">
                    <h3 class="card-title">
                  <i class="ion ion-clipboard mr-1"></i>
                  Comments List 
                </h3>
                </div>
                <div class="card-footer clearfix" v-if="checklistview">
                <div class="row">
                  <div class="col-sm-6">
                    <textarea class="form-control" v-model="addcomment" rows="5" id="comment"></textarea>
                  </div>
                  <div class="col-sm-6">
                    <button type="button" class="btn btn-primary float-right" @click="addCommentsListData" ><i class="fas fa-plus"></i> Add Comments</button>
                    
                  </div>
                </div>
              </div>
              <div class="card-body">
                <ul class="todo-list" data-widget="todo-list">
                  
                  <li v-for="val in getCommentsListDash" :key="val">
                    <span class="handle">
                      <i class="fas fa-ellipsis-v"></i>
                      <i class="fas fa-ellipsis-v"></i>
                    </span>

                      <!-- checkbox -->
                      <div  class="icheck-primary d-inline ml-2">                      
                        <div class="text">{{val.commentlist1}}</div>
                    </div>
                    <div class="toolss" >
                      <span class="ml-2" style="float:right;    margin-top: -27px;">Created By: <b>{{val.userdetails?val.userdetails.name:''}}</b></span>
                      <br/>
                      <span class="ml-2" style="float:right;    margin-top: -27px;">Date:<b>{{moment(val.sdaate)}}</b></span>
                      
                    </div>
                   </li>

                </ul>
              </div>
            </div>
          </div>
        </div>
            <div class="modal-footer justify-content-between">
              <button type="button" id="close" class="btn btn-default" data-dismiss="modal"  @click="close">Close</button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
 </section>
 <div class="modal fade" id="modal-default-addDepart">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Add Task</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form v-on:submit.prevent="submitTask"  id="addTasksubmit" ref="textareaform">

                <div class="card-body row">
                  <div class="col-sm-6">
                        <div class="form-group">
                            <label for="exampleInputEmail1">Title</label>
                            <input type="text" v-model="title" class="form-control" id="title" placeholder="Enter title" required>
                        </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="exampleInputEmail1">Description</label>
                      <textarea class="form-control" v-model="taskdescription" rows="2" id="description" required></textarea>
                    </div>

                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="exampleInputEmail1">Goal</label>
                      <select
                        v-model="Projectid"
                        class="form-control"
                        style="width: 100%"
                      >
                       <option v-for="valuedept in fetchDepart.projects" :key="valuedept.id" :value="valuedept.id" >{{valuedept.projectName}}</option>
                      </select>
                    </div>
                  </div>
                  <!-- <div class="col-sm-6">
                        <div class="form-group">
                        <label for="exampleInputEmail1">Entity <span>(optional)</span></label>
                        <select
                        v-model="entity"
                        class="form-control select2bs4"
                        style="width: 100%"
                        >
                        <option v-for="valuedept in fetchEntity" :value="valuedept.id" :key="valuedept.id">{{valuedept.entityname}}</option>
                    
                        </select>
                        </div>
                    </div> -->
                  <!-- <div class="col-sm-6">
                        <div class="form-group">
                            <label for="exampleInputEmail1">Super Project</label>
                            <select
                        v-model="subproject"
                        class="form-control select2bs4"
                        style="width: 100%"
                        >
                        <option v-for="valuedept in fetchSubproject" :value="valuedept.id" :key="valuedept.id">{{valuedept.projectname}}</option>
                        </select>
                        </div>
                  </div> -->
                  <!-- <div class="col-sm-6">
                    <div class="form-group">
                      <label for="exampleInputEmail1">department</label>
                    
                      <select
                        v-model="department"
                        class="form-control select2bs4"
                        style="width: 100%"
                      >
                       <option v-for="valuedept in fetchDepart.DeptList" :key="valuedept.name">{{valuedept.name}}</option>
                      </select>
                    </div>
                  </div> -->

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="exampleInputEmail1">Assign Users</label>
                      <Multiselect
                          v-model="user"
                          placeholder="Select Task Assign User"
                          label="name"
                          valueProp="userId"
                          multiplelabel="name"
                          track-by="name"
                          :close-on-select="true"
                          :searchable="true"
                          :options='fetchUsers'>
                        </Multiselect>
                      <!-- <select
                        v-model="user"
                        class="form-control select2bs4"
                        style="width: 100%"
                      >
                       <option v-for="valuedept in fetchUsers" :key="valuedept.name">{{valuedept.name}}</option>
                      </select> -->
                    </div>
                  </div>
                  
                 
                  <!-- <div class="col-sm-6">
                        <div class="form-group">
                            <label for="exampleInputEmail1">Progress</label>
                            <select v-model="Progress" class="form-control select2bs4" style="width: 100%">
                                    <option value="todo">Todo</option>
                                    <option value="inprogress">Inprogress</option>
                                    <option value="reviews">Reviews</option>
                                    <option value="done">Done</option>
                          </select>
                        </div>
                  </div> -->
                  <div class="col-sm-6">
                        <div class="form-group">
                            <label for="exampleInputEmail1">Priority</label>
                            <select v-model="Priority" class="form-control select2bs4" required style="width: 100%">
                                    <option value="Urgent">Urgent</option>
                                    <option value="Important">Important</option>
                                    <option value="Medium">Medium</option>
                                    <option value="Low">Low</option>
                          </select>
                        </div>
                  </div>
                  <div class="col-sm-6">
                        <div class="form-group">
                            <label for="exampleInputEmail1">Due Date</label>
                           <input type="date" v-model="Duedate" class="form-control" />
                        </div>
                  </div>
                </div>
                <!-- /.card-body -->

                <div class="card-footer">
                  <button type="submit" class="btn btn-primary">Submit</button>
                </div>
              </form>
            </div>
            <div class="modal-footer justify-content-between">
              <button type="button" id="close1" class="btn btn-default" data-dismiss="modal"  @click="close">Close</button>

            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
</template>

<script>
import draggable from 'vuedraggable'
import { mapGetters,mapActions } from "vuex"
import Multiselect from '@vueform/multiselect'
import moment from 'moment'
import axios from 'axios'
export default {
  components: {
    draggable,
    Multiselect,
  },

  computed: {
    ...mapActions(['fetchDashboardEntity','getCommentsListdata','GetSearchByUserList','fetchProjects','GetTodoList','GetInprogressList','GetTestingList','GetDoneList','GetUsers','getActionListdata']),
    ...mapGetters(['getDashboardWiseEntity','getCommentsListDash','getLoginWiseUser','fetchDepart','fetchProject','fetchTODO','fetchINPROGRESS','fetchTESTING','fetchDONE','fetechUserTask','fetchUsers','fetchChecklist','getActionListDash']),
    fetchTODO: {
        get() {
            return this.$store.getters['fetchTODO']
        },
        set(value) {
          this.$store.commit('getTODO', value)
         // console.log('TODO set',value);
          let i=1;

          value.forEach((value) => {
           // console.log(value)
            let payload={
              taskid:value.taskid,
              projectid:value.projectid,
              depart:value.depart,
              userName:value.userName,
              title:value.title,
              assign:value.assign,
              priority:value.priority,
              progress:'todo',
              position:i,
              duedate:value.duedate,
              taskprojectID:'',
              sdate:value.sdate,
              entyid:value.entyid,
            }
            this.$store.dispatch('updateTaskListTodo',payload);
            i++;
          });

          i=1;


        
        }
    },
    fetchINPROGRESS:{
      get() {
            return this.$store.getters['fetchINPROGRESS']
        },
        set(value) {
          this.$store.commit('getInprogress', value)
         // console.log('Inprogress set',value);
          let j=1;

          value.forEach((value) => {
            //console.log(value)
            let payload={
              taskid:value.taskid,
              projectid:value.projectid,
              depart:value.depart,
              userName:value.userName,
              title:value.title,
              assign:value.assign,
              priority:value.priority,
              progress:'inprogress',
              position:j,
              duedate:value.duedate,
              sdate:value.sdate,
              entyid:value.entyid,
            }
            this.$store.dispatch('updateTaskListTodo',payload);
            j++;
          });

          j=1;

       
        }
    },
    fetchTESTING:{
      get() {
            return this.$store.getters['fetchTESTING']
        },
        set(value) {
          this.$store.commit('getTesting', value)
         // console.log('testing set',value);
          let k=1;

          value.forEach((value) => {
           // console.log(value)
            let payload={
              taskid:value.taskid,
              projectid:value.projectid,
              depart:value.depart,
              userName:value.userName,
              title:value.title,
              assign:value.assign,
              priority:value.priority,
              progress:'reviews',
              position:k,
              duedate:value.duedate,
              sdate:value.sdate,
              entyid:value.entyid,
            }
            this.$store.dispatch('updateTaskListTodo',payload);
            k++;
          });

          k=1;

        
        }
    },
    fetchDONE:{
      get() {
            return this.$store.getters['fetchDONE']
        },
        set(value) {
          this.$store.commit('getDone', value)
         // console.log('done set',value);
          let j=1;

          value.forEach((value) => {
           // console.log(value)
            let payload={
              taskid:value.taskid,
              projectid:value.projectid,
              depart:value.depart,
              userName:value.userName,
              title:value.title,
              assign:value.assign,
              priority:value.priority,
              progress:'done',
              position:j,
              duedate:value.duedate,
              sdate:value.sdate,
              entyid:value.entyid,
            }
           
            this.$store.dispatch('updateTaskListTodo',payload);
            j++;
          });

          j=1;

       
        }
    }
      },
  mounted(){
    
    this.getGettersData();
    this.getmethodColumn();
  },
  updated() {
    
    this.formula=100 / this.fetchChecklist.length;
    this.maincnt=this.count*this.formula;

  },
  data() {
    return {
      // for new tasks
      newTask: "",
      ActivityLog:'',
      // 4 arrays to keep track of our 4 statuses
      arrBackLog: [],
      arrInProgress: [],
      arrTested: [],
      arrDone: [],
      title:'',
      user:null,
      taskprojectID:'',
      taskID:'',
      tasktitle:'',
      count:0,
      maincnt:'',
      formula:'',
      addchecklist:'',
      ckEditor:'',
      content:'',
      addaction:'',
      hod:'',
      checklistview:false,
      searchUser:'',
      taskdescription:'',
      Projectid:'',
      Priority:'Low',
      Duedate:'',
      searchProject:'',
      addcomment:'',
      searchEntity:'',
      description:'',
    };
  },
  methods: {
    onMove: function(event, param) {
      console.log('param',param);
      console.log('event',event);
    },
    moment: function (date) {
        if(date){
          return moment(date).format('DD-MM-Y');
        }
    },
     getFullName: function() {
      var optionAxios = {
                  headers: {
                                  'Accept': 'text/plain'
                          }                         }
                axios.get(`https://tmsapi.areteonline.in/api/users/1`,optionAxios)
                .then((res) => {
                      return res.data.name;
                  })

		},
    
    getuserdetailsID(s){
      var optionAxios = {
                  headers: {
                                  'Accept': 'text/plain'
                          }                         }
                 axios.get(`https://tmsapi.areteonline.in/api/users/${s}`,optionAxios)
                .then((res) => {
                      return res.data;
                  })
              
    },
    addCommentsListData(){

      let payload={
        id:'0',
        entyid :null,
        sprojectid:null,
        projectid:this.fetechUserTask.projectid,
        tasklistid:this.fetechUserTask.taskid,
        username:localStorage.getItem('userID'),
        commentlist1:this.addcomment,
        department:localStorage.getItem('department'),
        status:'false',
      }

         console.log('**Comments**',payload);
        this.$store.dispatch('InsertCommentsListTask',payload);
        this.addcomment='';

},
    updateform(){
      this.checklistview=true;
    },
    async submitTask(event){

         let s='';
          if(this.user){
             s=this.user;
          }else{
             s=localStorage.getItem('userID');
          }

         this.close();
         document.getElementById('close1').click();


         var optionAxios1 = {
            headers: {
                            'Accept': 'text/plain'
                    }                         }
          const responsed = await axios.get(`https://tmsapi.areteonline.in/api/projects/${this.Projectid}`,optionAxios1)
          const data1 = responsed.data;



    
        var optionAxios = {
            headers: {
                            'Accept': 'text/plain'
                    }                         }
          const response = await axios.get(`https://tmsapi.areteonline.in/api/users/${s}`,optionAxios)
          const data = response.data;

      
        let sendmail={
        subject:'New Task Assign By '+localStorage.getItem('Username'),
        usermessage:'<table width="100%" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr><td align="center"><table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr><td align="center" valign="top" bgcolor="#66809b" style="background-size:cover;background-position:top" 400><table class="col-600" width="600" height="400" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr><td height="40"></td></tr><tr><td align="center" style="line-height:0"><img style="display:block;line-height:0;font-size:0;border:0" src="https://tms.areteonline.in/img/logo1.png" width="150" height="150" alt="logo"></td></tr><tr><td align="center" style="font-family:Raleway,sans-serif;font-size:37px;color:#fff;line-height:24px;font-weight:700;letter-spacing:7px">Goal-Tracker</td></tr><tr><td height="50"></td></tr></tbody></table></td></tr></tbody></table></td></tr><tr><td align="center"><table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0" style="margin-left:20px;margin-right:20px"><tbody><tr><td align="center"><table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0" style="border-left:1px solid #dbd9d9;border-right:1px solid #dbd9d9"><tbody><tr><td height="50"></td></tr><tr><td align="right"><table width="500" border="0" align="left" cellpadding="0" cellspacing="0" class="col2" style=""><tbody><tr><td align="center"><table class="insider" width="400" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr align="left"><td style="font-family:Raleway,sans-serif;font-size:23px;color:#2a3b4c;line-height:30px;font-weight:700">Task Assign</td></tr><tr><td height="5"></td></tr><tr><td style="font-family:Lato,sans-serif;font-size:14px;color:#7f8c8d;line-height:24px;font-weight:300"><p>You have a task due in Goal-Tracker.  <a href="https://tms.areteonline.in">Click here</a> </p>  <table style="font-family:arial,sans-serif;border-collapse:collapse;width:100%;border:1px solid #000"><thead><tr style="border:1px solid"><th style="border:1px solid">Date</th><th style="border:1px solid">Task</th></tr></thead><tbody><tr style="border:1px solid"><td style="border:1px solid" align="center" >'+this.moment(this.Duedate)+'</td><td style="border:1px solid" align="center" >'+this.title+'</td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></td></tr><tr><td align="center"><table align="center" width="100%" border="0" cellspacing="0" cellpadding="0" style="border-left:1px solid #dbd9d9;border-right:1px solid #dbd9d9"><tbody><tr><td height="50"></td></tr><tr><td align="center" bgcolor="#34495e"  height="185"><table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr><td height="25"></td></tr><tr><td height="25"></td></tr></tbody></table><table align="center" width="35%" border="0" cellspacing="0" cellpadding="0"></table></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table>',
        username:data.name,
        useremail:data.email,
        }

        this.$store.dispatch('SendTaskAssign',sendmail);

    
      setTimeout(() => {

        let payload={
         projectid:this.Projectid,
         depart:localStorage.getItem('department'),
         sdate:this.Duedate,
         userName:localStorage.getItem('userID'),
         title:this.title,
         assign:s,
         progress:'todo',
         priority:this.Priority,
         position:this.Position,
         duedate:this.Duedate,
         entyid:data1.entyid,
         sprojectid:'',
         description:this.taskdescription,
      }


       console.log('-sdf---',payload);
       this.$store.dispatch('TaskInsert',payload);
       this.$store.dispatch('ActionUserWiseTaskList',localStorage.getItem('userID'));
       this.title='';
       this.Priority='';
       this.Position='';
       this.Duedate='';
       this.taskdescription='';
       this.Projectid='';
       this.user='';
       document.getElementById("addTasksubmit").reset();

       this.$swal({
              text: 'Successfully Inserted record.',
              target: '#custom-target',
              customClass: {
                container: 'position-absolute'
              },
              toast: true,
              position: 'top'
          });

       event.target.reset();
       this.getmethodColumn();

        
      }, 500);   
      
      

  },
    async submitTask2(){

      try{

        
        var result='';
          if(this.user){

             result = this.user.map(function(val) {
              return val;
            }).join(',');
          }else{ result ='';}

               let s='';
                if(result){
                   s=result;
                }else{
                   s=localStorage.getItem('userID');
                }

                const arr = s.split(',');

                console.log('results',arr);

               this.close();
               document.getElementById('close1').click();
               var temp = new Array();

            for (let index = 0; index < arr.length; index++) {
              const element = arr[index];

              var optionAxios = {
                  headers: {
                                  'Accept': 'text/plain'
                          }                         }
                const response = await axios.get(`https://tmsapi.areteonline.in/api/users/${element}`,optionAxios)
                const data = response.data;
                temp.push(data.userId);

            
              let sendmail={
              subject:'New Task Assign By '+localStorage.getItem('Username'),
              usermessage:'<table width="100%" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr><td align="center"><table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr><td align="center" valign="top" bgcolor="#66809b" style="background-size:cover;background-position:top" 400><table class="col-600" width="600" height="400" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr><td height="40"></td></tr><tr><td align="center" style="line-height:0"><img style="display:block;line-height:0;font-size:0;border:0" src="https://tms.areteonline.in/img/logo1.png" width="150" height="150" alt="logo"></td></tr><tr><td align="center" style="font-family:Raleway,sans-serif;font-size:37px;color:#fff;line-height:24px;font-weight:700;letter-spacing:7px">Goal-Tracker</td></tr><tr><td height="50"></td></tr></tbody></table></td></tr></tbody></table></td></tr><tr><td align="center"><table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0" style="margin-left:20px;margin-right:20px"><tbody><tr><td align="center"><table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0" style="border-left:1px solid #dbd9d9;border-right:1px solid #dbd9d9"><tbody><tr><td height="50"></td></tr><tr><td align="right"><table width="500" border="0" align="left" cellpadding="0" cellspacing="0" class="col2" style=""><tbody><tr><td align="center"><table class="insider" width="400" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr align="left"><td style="font-family:Raleway,sans-serif;font-size:23px;color:#2a3b4c;line-height:30px;font-weight:700">Task Assign</td></tr><tr><td height="5"></td></tr><tr><td style="font-family:Lato,sans-serif;font-size:14px;color:#7f8c8d;line-height:24px;font-weight:300"><p>You have a task due in Goal-Tracker. <a href="https://tms.areteonline.in">Click here</a> </p>  <table style="font-family:arial,sans-serif;border-collapse:collapse;width:100%;border:1px solid #000"><thead><tr style="border:1px solid"><th style="border:1px solid">Date</th><th style="border:1px solid">Task</th></tr></thead><tbody><tr style="border:1px solid"><td style="border:1px solid">'+this.Duedate+'</td><td style="border:1px solid">'+this.title+'</td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></td></tr><tr><td align="center"><table align="center" width="100%" border="0" cellspacing="0" cellpadding="0" style="border-left:1px solid #dbd9d9;border-right:1px solid #dbd9d9"><tbody><tr><td height="50"></td></tr><tr><td align="center" bgcolor="#34495e"  height="185"><table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr><td height="25"></td></tr><tr><td height="25"></td></tr></tbody></table><table align="center" width="35%" border="0" cellspacing="0" cellpadding="0"></table></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table>',
              username:data.name,
              useremail:data.email,
              }

              this.$store.dispatch('SendTaskAssign',sendmail);

              
            } 
            let nameed= temp.toString()
            console.log('temp',nameed);
      


            setTimeout(() => {

              let payload={
                taskid:0,
               projectid:this.Projectid,
               depart:localStorage.getItem('department'),
               sdate:this.Duedate,
               userName:localStorage.getItem('userID'),
               title:this.title,
               assign:nameed,
               progress:'todo',
               priority:this.Priority,
               position:this.Position,
               duedate:this.Duedate,
               entyid:'',
               sprojectid:'',
               description:this.taskdescription,
            }


             console.log('-sdf---',payload);
             this.$store.dispatch('TaskInsert',payload);

             this.$swal({
                    text: 'Successfully Inserted record.',
                    target: '#custom-target',
                    customClass: {
                      container: 'position-absolute'
                    },
                    toast: true,
                    position: 'top'
                });
                this.$router.push('dashboard');

                
                this.$store.dispatch('GetTodoList',localStorage.getItem('userID'));
                this.$store.dispatch('GetInprogressList',localStorage.getItem('userID'));
                this.$store.dispatch('GetTestingList',localStorage.getItem('userID'));
                this.$store.dispatch('GetDoneList',localStorage.getItem('userID'));
                

                
              }, 500);   

    } catch (err) {
      this.$router.push('dashboard');

          // Handle error
          // console.log(err);
         

      }


            

        },
   
    async submitTask1(){
          var result='';
          if(this.user){

             result = this.user.map(function(val) {
              return val;
            }).join(',');
          }else{ result ='';}

               let s='';
                if(result){
                   s=result;
                }else{
                   s=localStorage.getItem('userID');
                }

                const arr = s.split(',');

                console.log('results',arr);

               this.close();
               document.getElementById('close1').click();
               var temp = new Array();

            for (let index = 0; index < arr.length; index++) {
              const element = arr[index];

              var optionAxios = {
                  headers: {
                                  'Accept': 'text/plain'
                          }                         }
                const response = await axios.get(`https://tmsapi.areteonline.in/api/users/${element}`,optionAxios)
                const data = response.data;
                temp.push(data.userID);

            
              // let sendmail={
              // subject:'Task Assign For you',
              // usermessage:'<table width="100%" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr><td align="center"><table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr><td align="center" valign="top" bgcolor="#66809b" style="background-size:cover;background-position:top" 400><table class="col-600" width="600" height="400" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr><td height="40"></td></tr><tr><td align="center" style="line-height:0"><img style="display:block;line-height:0;font-size:0;border:0" src="https://tms.areteonline.in/img/logo1.png" width="300" height="150" alt="logo"></td></tr><tr><td align="center" style="font-family:Raleway,sans-serif;font-size:37px;color:#fff;line-height:24px;font-weight:700;letter-spacing:7px">TMS<span style="font-family:Raleway,sans-serif;font-size:37px;color:#fff;line-height:39px;font-weight:300;letter-spacing:7px">Notification</span></td></tr><tr><td height="50"></td></tr></tbody></table></td></tr></tbody></table></td></tr><tr><td align="center"><table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0" style="margin-left:20px;margin-right:20px"><tbody><tr><td align="center"><table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0" style="border-left:1px solid #dbd9d9;border-right:1px solid #dbd9d9"><tbody><tr><td height="50"></td></tr><tr><td align="right"><table width="500" border="0" align="left" cellpadding="0" cellspacing="0" class="col2" style=""><tbody><tr><td align="center"><table class="insider" width="400" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr align="left"><td style="font-family:Raleway,sans-serif;font-size:23px;color:#2a3b4c;line-height:30px;font-weight:700">Task Assign</td></tr><tr><td height="5"></td></tr><tr><td style="font-family:Lato,sans-serif;font-size:14px;color:#7f8c8d;line-height:24px;font-weight:300">We create responsive websites with modern designs and features for small businesses and organizations that are professionally developed and SEO optimized.</td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></td></tr><tr><td align="center"><table align="center" width="100%" border="0" cellspacing="0" cellpadding="0" style="border-left:1px solid #dbd9d9;border-right:1px solid #dbd9d9"><tbody><tr><td height="50"></td></tr><tr><td align="center" bgcolor="#34495e" background="https://designmodo.com/demo/emailtemplate/images/footer.jpg" height="185"><table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr><td height="25"></td></tr><tr><td height="25"></td></tr></tbody></table><table align="center" width="35%" border="0" cellspacing="0" cellpadding="0"></table></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table>',
              // username:data.name,
              // useremail:data.email,
              // }

              // this.$store.dispatch('SendTaskAssign',sendmail);

              
            } 
            let nameed= temp.toString()
            console.log('temp',nameed);
      


            setTimeout(() => {

              let payload={
               projectid:this.Projectid,
               depart:localStorage.getItem('department'),
               sdate:this.Duedate,
               userName:localStorage.getItem('userID'),
               title:this.title,
               assign:nameed,
               progress:'todo',
               priority:this.Priority,
               position:this.Position,
               duedate:this.Duedate,
               entyid:'',
               sprojectid:''
            }


             console.log('-sdf---',payload);
             this.$store.dispatch('TaskInsert',payload);

             event.target.reset();

             this.$store.dispatch('GetTodoList',localStorage.getItem('userID'));
             this.$store.dispatch('GetInprogressList',localStorage.getItem('userID'));
             this.$store.dispatch('GetTestingList',localStorage.getItem('userID'));
             this.$store.dispatch('GetDoneList',localStorage.getItem('userID'));
              
            }, 500);   
            
        },
    onChange(event) {
            console.log(event.target.value)
           // let name=event.target.value;
           let project=event.target.value;
           if(project=='All'){
              this.getmethodColumn();
           }else
           {
             let payload={
               searchproject:event.target.value,
               username:localStorage.getItem('userID')
              }
              this.$store.dispatch('GetSearchbyProjectTODO',payload);
              this.$store.dispatch('GetSearchbyProjectINPROGRESS',payload);
              this.$store.dispatch('GetSearchbyProjectTESTING',payload);
              this.$store.dispatch('GetSearchbyProjectDONE',payload);
            }
              
        },
    onChangeEntity(event){
      console.log(event.target.value)

      let entity=event.target.value;

      if(entity=='All'){
              this.getmethodColumn();
          }else{

       
       let payload={
         searchEntity:event.target.value,
         username:localStorage.getItem('userID')
        }
        
        this.$store.dispatch('GetSearchbyEntityTODO',payload);
        this.$store.dispatch('GetSearchbyEntityINPROGRESS',payload);
        this.$store.dispatch('GetSearchbyEntityTESTING',payload);
        this.$store.dispatch('GetSearchbyEntityDONE',payload);
      }


        },
    onChangeUser(event){
      console.log(event.target.value)

      let User=event.target.value;

      if(User=='All'){
              this.getmethodColumn();
           }else{

             
             let payload={
               searchUser:event.target.value,
               username:localStorage.getItem('userID')
              }
              
              this.$store.dispatch('GetSearchbyUserTODO',payload);
              this.$store.dispatch('GetSearchbyUserINPROGRESS',payload);
              this.$store.dispatch('GetSearchbyUserTESTING',payload);
              this.$store.dispatch('GetSearchbyUserDONE',payload);
            }

    },
    addActionListData(){

      let payload={
        id:'0',
        entyid :null,
        sprojectid:null,
        projectid:this.fetechUserTask.projectid,
        tasklistid:this.fetechUserTask.taskid,
        username:localStorage.getItem('userID'),
        actionlist1:this.addaction,
        department:localStorage.getItem('department'),
        status:'false',
      }

      // console.log('****',payload);
      this.$store.dispatch('InsertActionListTask',payload);
     this.addaction='';

     setTimeout(() => {
        this.$store.dispatch('GetTodoList',localStorage.getItem('userID'));
     this.$store.dispatch('GetInprogressList',localStorage.getItem('userID'));
     this.$store.dispatch('GetTestingList',localStorage.getItem('userID'));
     this.$store.dispatch('GetDoneList',localStorage.getItem('userID'));
      }, 1000);


    },
    format_date(value){
         if (value) {
          var date1 = new Date();
          var date2 = new Date(value);
         
          // To calculate the time difference of two dates
          var Difference_In_Time = date2.getTime() - date1.getTime();
            
          // To calculate the no. of days between two dates
          var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
          
          var intvalue = Math.floor( Difference_In_Days );

         // console.log('diff',Number(intvalue))
          let st='';
          if (intvalue > 0) {
              // Do Something
              st='Remaining days: ';
          }else{
            st='Over Due: ';
          }

           return st+intvalue+' ';
          }
      },
      format_date1(value){
         if (value) {
          var date1 = new Date();
          var date2 = new Date(value);
         
          // To calculate the time difference of two dates
          var Difference_In_Time = date1.getTime() - date2.getTime();
            
          // To calculate the no. of days between two dates
          var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
          
          var intvalue = Math.floor( Difference_In_Days );

         // console.log('diff',Number(intvalue))
          if(intvalue=='0'|| intvalue == 0){
            return 'Today';
            
          }else
          {
            return intvalue + ' Days';
          }

          }
      },
    log1(evt) {
          console.log('added',evt)      
      },
    log2: function(evt) {
        window.console.log('--inprogress---2',evt);          
      },
    filter(){
      var arrR = this.fetchChecklist.filter(function(ele){
        return (ele.status == "true")
      });
      this.count=arrR.length;
    },
    close() {
      this.checklistview=false;
        this.$emit('close');
      },
    submitTaskAcitivity(){
          
      let payload={
                taskid:this.fetechUserTask.taskid,
                Projectid:this.fetechUserTask.projectid,
                Depart:this.fetechUserTask.depart,
                sdate:null,
                userName:localStorage.getItem('userID'),
                title:this.tasktitle,
                description:this.description,
                assign:this.fetechUserTask.assign,
                Progress:this.fetechUserTask.progress,
                Priority:this.fetechUserTask.priority,
                Position:this.fetechUserTask.position,
                Duedate:this.editDuedateUpdate,
                entyid:this.entyid,
                sprojectid:''
            }

          this.$store.dispatch('updateTaskDetails',payload);
          this.close();
          document.getElementById('close').click();


    },
    addCheckListData(){

        let payload={
        entyid :null,
        sprojectid:null,
        projectid:this.fetechUserTask.projectid,
        tasklistid:this.fetechUserTask.taskid,
        username:localStorage.getItem('userID'),
        checklist1:this.addchecklist,
        department:localStorage.getItem('department'),
        status:'false',
      }

      this.$store.dispatch('InsertCheckListupdate',payload);
      this.addchecklist='';

      setTimeout(() => {
        this.$store.dispatch('GetTodoList',localStorage.getItem('userID'));
     this.$store.dispatch('GetInprogressList',localStorage.getItem('userID'));
     this.$store.dispatch('GetTestingList',localStorage.getItem('userID'));
     this.$store.dispatch('GetDoneList',localStorage.getItem('userID'));
      }, 1000);

    },
    async checkboxclick(a,$event){
      console.log('*****',a)
      const checked = $event.target.checked;
      console.log(checked)

      let payload={
        id:a.id,
        entyid :null,
        sprojectid:null,
        projectid:a.projectid,
        tasklistid:a.tasklistid,
        username:a.username,
        checklist1:a.checklist1,
        department:a.department,
        status:checked,
      }

      console.log('payload',payload);

      await this.$store.dispatch('updateCheckListupdate',payload);
      setTimeout(() => {
        
        this.filter();

    
      }, 100);
      setTimeout(() => {
        this.$store.dispatch('GetTodoList',localStorage.getItem('userID'));
     this.$store.dispatch('GetInprogressList',localStorage.getItem('userID'));
     this.$store.dispatch('GetTestingList',localStorage.getItem('userID'));
     this.$store.dispatch('GetDoneList',localStorage.getItem('userID'));
      }, 1000);

    },
   async taskActivity(id){
    
     await this.$store.dispatch('getTaskdetailsUser',id);
     await this.$store.dispatch('getCheckListdetailsUser',id);
     await this.$store.dispatch('getActionListdata',id);
     await this.$store.dispatch('getCommentsListdata',id);
     
     this.tasktitle=this.fetechUserTask.title;
     this.description=this.fetechUserTask.description;
     this.editDuedateUpdate=moment(String(this.fetechUserTask.duedate)).format('YYYY-MM-DD');
     var result =this.fetechUserTask.assign;
     
     var temp = new Array();
          temp.push(this.fetechUserTask.assign);
          console.log('temp',temp);
          
     let main=result;
     console.log([main]);
    this.GetArray(temp);
 
     this.taskprojectID=this.fetechUserTask.projectid;
     this.taskID=this.fetechUserTask.taskid;
     this.hod=await this.getuserdetails(this.fetechUserTask.userName);
     // this.editprojectName=this.fetchrowSubprojects.projectname;
     this.filter();

  
    },
    async GetArray(id){
      var tem = new Array();
      for (let index = 0; index < id.length; index++) {
              const element = id[index];
             // alert(element)

              var optionAxios = {
          headers: {
                   'Accept': 'text/plain'
                  }                         }
          await  axios.get(`https://tmsapi.areteonline.in/api/users/${element}`,optionAxios)
              .then(function (res) {
                  // handle success
                  const data = res.data;
                tem.push(data.name);
              })
              .catch(function (error) {
                  // handle error
                  console.log(error);
              })
              .then(function () {
                  // always executed
                  console.log('--------s-')
              });

      }
      let nameed= tem.toString();
      this.Tskassignuser=nameed;

    },
    async getuserdetails(id){
      var optionAxios = {
                  headers: {
                                  'Accept': 'text/plain'
                          }                         }
                const response = await axios.get(`https://tmsapi.areteonline.in/api/users/${id}`,optionAxios)
                const data = response.data;
                return data.name;

    },
    //add new tasks method
    add: function() {
      if (this.newTask) {
        this.arrBackLog.push({ title: this.newTask });
        this.newTask = "";
      }
    },
    getGettersData(){
      this.arrBackLog=this.$store.getters['fetchTODO'];
      // this.arrInProgress=this.$store.getters['fetchINPROGRESS'];
      // this.arrTested=this.$store.getters['fetchTESTING'];
      // this.arrDone=this.$store.getters['fetchDONE'];
    },
    getmethodColumn()
    {
      this.$store.dispatch('GetUsers');
     this.$store.dispatch('GetTodoList',localStorage.getItem('userID'));
     this.$store.dispatch('GetInprogressList',localStorage.getItem('userID'));
     this.$store.dispatch('GetTestingList',localStorage.getItem('userID'));
     this.$store.dispatch('GetDoneList',localStorage.getItem('userID'));
     this.$store.dispatch('fetchProjects',localStorage.getItem('userID'));
     this.$store.dispatch('GetSearchByUserList',localStorage.getItem('userID'));
     this.$store.dispatch('fetchDashboardEntity',localStorage.getItem('userID'));
    },
 
}
}
</script>
<style scoped>
  .ms-Facepile {
    flex: 1 1 0px;
    min-height: 0px;
    min-width: 0px;
    display: flex;
    flex-flow: row nowrap;
    margin: 0px;
}
.ms-Facepile-itemContainer {
    flex: 1 1 0px;
    min-height: 0px;
    min-width: 0px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
}
 .ms-Facepile-members {
    flex: 0 0 auto;
    min-height: 0px;
    min-width: 0px;
    display: flex;
    flex-flow: row nowrap;
}

.plannerApp ul {
    margin: 0px;
    padding: 0px;
}
.members-256 {
    display: flex;
    overflow: hidden;
    list-style-type: none;
    padding: 0px;
    margin: 6px;
}
 .ms-Facepile-member {
    flex: 0 0 auto;
    min-height: 0px;
    min-width: 0px;
    margin: 0px 4px 6px;
}
.plannerApp li {
    list-style-type: none;
}
 .ms-Facepile-itemButton {
    flex: 0 0 auto;
    min-height: 0px;
    min-width: 0px;
    height: 24px;
}
.itemButton-254 {
    text-align: center;
    padding: 0px;
    border-radius: 50%;
    vertical-align: top;
    display: inline;
    background-color: transparent;
    border: none;
}
.coin-262 {
    font-family: "Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif;
    -webkit-font-smoothing: antialiased;
    font-size: 14px;
    font-weight: 400;
}
.imageArea-317 {
    position: relative;
    text-align: center;
    flex: 0 0 auto;
    height: 24px;
    width: 24px;
}
.initials-320 {
    border-radius: 50%;
    color: rgb(255, 255, 255);
    font-size: 10px;
    font-weight: 600;
    line-height: 24px;
    height: 24px;
    background-color: rgb(122, 117, 116);
}
.css-285 {
    display: flex;
    flex-flow: row nowrap;
    transition: color 0.167s ease-in-out 0s, background 0.167s ease-in-out 0s;
    border-top: 1px solid rgb(237, 235, 233);
    border-radius: 0px 0px 3px 3px;
    border-right-color: rgb(237, 235, 233);
    border-bottom-color: rgb(237, 235, 233);
    border-left-color: rgb(237, 235, 233);
}
.css-285 > .bottomBarLeftSection {
    display: flex;
    flex-flow: row nowrap;
    padding-left: 12px;
    margin-top: 4px;
}
.css-285 > .bottomBarRightSection {
    display: flex;
    flex-flow: row nowrap;
    right: 12px;
    position: absolute;
    margin-top: 6px;
}
.css-283.isLate {
    /* background-color: rgb(209, 52, 56); */
    border-radius: 2px;
    transition: background 0.167s ease-in-out 0s;
}
.css-283.clickable {
    border-radius: 3px !important;
    cursor: pointer;
}
.css-283 {
    display: inline-flex;
    flex-flow: row nowrap;
    align-items: center;
    height: 30px;
    cursor: default;
}
.css-283.isLate > .plannerIcon {
    color: rgb(255, 255, 255);
}
.root-286 {
    display: flex;
    color: rgb(33, 115, 70);
    padding-left: 2px;
    padding-right: 2px;
    align-items: center;
    justify-content: center;
}
.css-283.isLate .label {
    /* color: rgb(255, 255, 255); */
}
.toolss{
  font-size: 10px;
}
.card-title{
  font-size: 14px;
    font-weight: 600;
}
</style>
<style src="@vueform/multiselect/themes/default.css"></style>
